import { createSlice } from "@reduxjs/toolkit";

export interface SendToAppModalSlice {
    OOSModalIsOpen: boolean;
}

const sendToAppModal = createSlice({
    name: "sendToAppModal",
    initialState: {
        OOSModalIsOpen: false,
    } as SendToAppModalSlice,
    reducers: {
        openOOSModal(state): void {
            state.OOSModalIsOpen = true;
        },
        closeOOSModal(state): void {
            state.OOSModalIsOpen = false;
        },
    },
});

export const { openOOSModal, closeOOSModal } = sendToAppModal.actions;
export default sendToAppModal.reducer;
